import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertService } from '../../../shared/services/alert/Alert.service';
//import { ServerhandlerService } from 'src/app/modules/shared/services/serverHandler/serverhandler.service';
import { PersonalFileInfo } from '../../../shared/models/PersonalFileInfo';
import { DownloadTokenInfo } from '../../models/DownloadTokenInfo';
import { FilenameRequest } from '../../../shared/models/FilenameRequest';

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(private httpClient: HttpClient,
    //private serverHandlerService: ServerhandlerService,
    private alertService: AlertService) {
  }


  public files(projectId: string, folder: string, callback: any) {
    var self = this;
    var request = new FilenameRequest();
    request.folder = folder;

    // this.httpClient.post<PersonalFileInfo[]>(this.serverHandlerService.getUrl() + "/" + projectId +"/file/getPersonalFiles", request,
    // this.serverHandlerService.getHttpOptions()).subscribe(data => {
    //   const result = data as any;
    //   var resultData = result.body as PersonalFileInfo[];
    //   if (callback) callback(resultData);
    //   },
    //   error => {
    //     self.alertService.handleError(error);
    //   }
    // );
  }

  public deletePersonalFile(projectId: string, folder: string, filename: string, callback: { (result: boolean): void; (result: boolean): void; (result: boolean): void; }) {
    var self = this;
    var request = new FilenameRequest();
    request.folder = folder;
    request.filename = filename;

    // this.httpClient.post<boolean>(this.serverHandlerService.getUrl() + "/" + projectId +"/file/deletePersonalFile", request,
    // this.serverHandlerService.getHttpOptions()).subscribe(data => {
    //   const result = data as any;
    //   var resultData = result.body as boolean;
    //   if (callback) callback(resultData);
    //   },
    //   error => {
    //     self.alertService.handleError(error);
    //   }
    // );
  }

  public deletePersonalFiles(projectId: string, folder: string, callback: (result: boolean) => void) {
    var self = this;
    var request = new FilenameRequest();
    request.folder = folder;

    //this.httpClient.get<PartmodelsResponse>(this.serverHandlerService.getUrl() + '/squirrelfrontend/partmodels',
    // this.httpClient.post<boolean>(this.serverHandlerService.getUrl() + "/" + projectId +"/file/deletePersonalFiles", request,
    // this.serverHandlerService.getHttpOptions()).subscribe(data => {
    //     const result = data as any;
    //     var resultData = result.body as boolean;
    //     if (callback) callback(resultData);
    //   },
    //   error => {
    //     self.alertService.handleError(error);
    //   }
    // );
  }

  public downloadPersonalFile(projectId: string, folder: string, filename: string) {
    var self = this;

    var request = new FilenameRequest();
    request.folder = folder;
    request.filename = filename;

    // this.httpClient.post<DownloadTokenInfo>(this.serverHandlerService.getUrl() +"/" + projectId + '/file/createPersonalFileDownloadToken', request,
    // this.serverHandlerService.getHttpOptions()).subscribe(data => {
    //     const result = data as any;
    //     var tokeninfo = result.body as DownloadTokenInfo;
    //     const fileUrl = this.serverHandlerService.getUrl() +"/" + projectId + '/file/downloadPersonalFile/' + tokeninfo.token;
    //     self.downloadFile(fileUrl);
    //   },
    //   error => {
    //     self.alertService.handleError(error);
    //   }
    // );
  }

  public downloadFile(fileUrl: string, filename: string = '') {
    const a = document.createElement('a');
    a.href = fileUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

}

